import enUS from '@/i18n/locales/en-US'
import zhHK from '@/i18n/locales/zh-HK'
import zhTW from '@/i18n/locales/zh-TW'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// restore from local storage
let i18nextLng = localStorage.getItem('i18nextLng')
if (!i18nextLng) {
  // if local storage not config
  i18nextLng = 'zh-HK'
  localStorage.setItem('i18nextLng', i18nextLng)
}

const resources = {
  'en-US': {
    translation: enUS,
  },
  'zh-HK': {
    translation: zhHK,
  },
  'zh-TW': {
    translation: zhTW,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: i18nextLng, // 預設語言
    fallbackLng: i18nextLng, // 如果當前切換的語言沒有對應的翻譯則使用這個語言，
    interpolation: {
      escapeValue: false, // 如果語系檔中有巢狀的結構，則 escapeValue 要設為 false，這樣就可以透過物件的方式來取得巢狀內的翻譯
    },
  })

export default i18n
